import React, { useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import NetlifyForm from "react-netlify-form";
// import Icon from './icon';

const PodcastList = ({ body, pageContext }) => {
    const [hideEpisodes, setHideEpisodes] = useState(true);
    const [activeStream, setActiveStream] = useState('spotify');
    const [activeCount, setActiveCount] = useState(3);
    const perLoad = 4;
    // console.log(pageContext.nodes);

    const displayMore = () => {
        const newCount = activeCount + perLoad;
        setActiveCount(newCount);
        // console.log(pageContext.nodes.length, newCount)
        if (pageContext.nodes.length <= newCount) {
            setHideEpisodes(false);
        }
    }

    const resetDisplay = (stream) => {
        setActiveStream(stream);
        setActiveCount(3);
        setHideEpisodes(true);
    }

    useMemo(() => {
        // Re-render on count update
    }, [activeCount]);

    return (
        <div id="podcastList" className="container">
            <div className="row">
                <div className="col-12 center-col">
                    <div className="row">
                        <div className="col-12 podcast-header">
                            <h6 className="eyebrow">PODCAST</h6>
                            <div className="page-heading__body">{body && <ReactMarkdown source={body} />}</div>
                            <h5>Are you interested in working for one of our portfolio companies?</h5>
                            <a href="https://coda.io/form/KP-Talent-on-Market-Submit-Yourself_dr9BL_KyyV2" target="_blank" onClick={typeof ga !== 'undefined' && ga('send', 'event', {
                                eventCategory: 'Outbound Link',
                                eventAction: 'click',
                                eventLabel: 'https://coda.io/form/KP-Talent-on-Market-Submit-Yourself_dr9BL_KyyV2',
                                transport: 'beacon'
                            })} className="btn">Apply</a>
                        </div>
                        <div className="col-6"></div>
                    </div>

                    <div className="row">
                        <div className={`col-12 podcast-episodes ${hideEpisodes ? 'hideEpisodes' : ''}`}>
                            <h4 className="streaming-toggle"><span className="title">Listen on: </span><span role="presentation" onClick={() => resetDisplay('spotify')} className={`icon spotify ${activeStream === 'spotify' ? 'active' : ''}`}>Spotify</span><span className="separate"></span><span role="presentation" onClick={() => resetDisplay('apple')} className={`icon apple ${activeStream === 'apple' ? 'active' : ''}`}>Apple</span></h4>
                            {pageContext.nodes.map((node, nodeIndex) => (
                                <React.Fragment key={nodeIndex}>
                                    {node.embed && !(node.embed.startsWith('<iframe')) && nodeIndex <= activeCount && activeStream === 'spotify' && (
                                        <iframe className={`embed spotify ${activeStream === 'spotify' ? 'active' : ''}`} src={`https://open.spotify.com/embed-podcast/episode/${node.embed}`} width="100%" height="232" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                                    )}
                                    {node.appleEmbed && !(node.appleEmbed.startsWith('<iframe')) && nodeIndex <= activeCount && activeStream === 'apple' && (
                                        <iframe className={`embed apple ${activeStream === 'apple' ? 'active' : ''}`} src={`https://embed.podcasts.apple.com/us/podcast/go-to-market-grit/id1510985491?i=${node.appleEmbed}`} width="100%" height="175" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <span role="presentation" className={`seeMore ${!hideEpisodes ? 'hide' : ''}`} onClick={() => displayMore()}>See more</span>
                    </div>

                    <div className="row podcast-banner">
                        <div className="col-12">
                            <h2>Sign-up for podcast updates</h2>
                        </div>
                        <div className="col-12">
                            <NetlifyForm name="gtmg_mailing_list">
                                {({ loading, error, success }) => (
                                    <div>
                                    {loading &&
                                        <div className="h3 form-message fw--300">Loading...</div>
                                    }
                                    {error &&
                                        <div className="h3 form-message fw--300">Your information was not sent. Please try again later.</div>
                                    }
                                    {success &&
                                        <div className="h3 form-message fw--300">Thank you for subscribing!</div>
                                    }
                                    {!loading && !success &&
                                        <div>
                                            <input type="hidden" name="campaign" value="GTMG Podcast Mailing List" />
                                            <div className="form-group">
                                                <label>
                                                    <span className="sr-only">Name</span>
                                                    <input name="name" type="text" placeholder="Name" required />
                                                </label>
                                                <label>
                                                    <span className="sr-only">Email</span>
                                                    <input name="email" type="email" placeholder="Email" required />
                                                </label>
                                                <div className="form-submit">
                                                    <button type="submit">Sign up</button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    </div>
                                )}
                            </NetlifyForm>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PodcastList